import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card, CardMedia, IconButton, Container } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { getOurCategories } from '../../services/OurCategories';
import { useNavigate } from 'react-router-dom';

const OurCategories = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const [ourCategoriesData, setOurCategoriesData] = useState([])
    const navigate = useNavigate();

    const getOurCategoriesData = async () => {
        try {
            const response = await getOurCategories();
            setOurCategoriesData(response?.categoryData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getOurCategoriesData();
    }, []);

    return (
        <Container sx={{ pt: { lg: 5, xs: 3 }, pb: { lg: 12, xs: 3 }, textAlign: 'center' }}>
            <Typography
                data-aos="fade-up"
                data-offset="200"
                variant={isSmallScreen ? 'h5' : 'h4'}
                sx={{ fontWeight: 700 }}
                gutterBottom
            >
                Our Categories
            </Typography>
            <Typography data-aos="fade-up" data-offset="200" variant="subtitle1" sx={{ mb: { lg: 6, xs: 3 } }}>
                Browse Our Best-Selling Collections for Stylish and Functional Home Solutions
            </Typography>
            <Grid container rowSpacing={isSmallScreen ? 4 : 6} columnSpacing={3}>
                {ourCategoriesData.map((category, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index} data-aos="zoom-in"
                        data-aos-delay={`${index * 100}`}>
                        <Card
                            onClick={() => navigate(`/product/${category?._id}`)}
                            sx={{
                                borderRadius: '0',
                                position: 'relative',
                                overflow: 'visible',
                                boxShadow: 'none',
                                '&:hover .title': {
                                    backgroundColor: '#01A0E2',
                                    color: '#fff'
                                }, height: '100%',
                                cursor: 'pointer'
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={category.image.url}
                                alt={category.name}
                                sx={{ borderRadius: '0', height: '100%' }}
                            />
                            <Box
                                className="title"
                                sx={{
                                    position: 'absolute',
                                    left: '0', bottom: '50px',
                                    zIndex: 11,
                                    backgroundColor: 'white',
                                    width: { sm: '90%', xs: '75%' },
                                    py: 0.5,
                                    clipPath: 'polygon(0 0, 100% 0%, 90% 100%, 0% 100%)',
                                    display: 'inline-block'
                                }}>
                                <Typography className='title' variant={isSmallScreen ? "body1" : "h6"} sx={{ textAlign: 'left', ml: 2 }}>{category.name}</Typography>
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    right: '1px', bottom: '-10px',
                                    zIndex: 111,
                                    backgroundColor: '#fff',
                                    width: { sm: '55%', xs: '45%' },
                                    border: '1px solid white',
                                    color: '#fff',
                                    py: 0.5,
                                    clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 10% 100%)',
                                    display: 'inline-block'
                                }} >
                                <Typography variant={isSmallScreen ? "body1" : "h6"} sx={{ textAlign: 'right', mr: 2, color: '#fff' }}>Order Now</Typography>
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    right: 0, bottom: '-10px',
                                    zIndex: 1111,
                                    backgroundColor: '#212529',
                                    width: { sm: '55%', xs: '45%' },
                                    border: '1px solid white',
                                    color: '#fff',
                                    py: 0.5,
                                    clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 10% 100%)',
                                    display: 'inline-block'
                                }}>
                                <Typography variant={isSmallScreen ? "body1" : "h6"} sx={{ textAlign: 'right', mr: 2, color: '#fff' }}>Order Now</Typography>
                            </Box>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    opacity: 0,
                                    transition: 'opacity 0.3s ease-in-out',
                                    background: '#00000080',
                                    '&:hover': {
                                        opacity: 1,
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translate(-50%, -0%)',
                                        top: '40%', textAlign: 'center',
                                        color: '#0A2357',
                                        width: 'inherit',
                                    }}
                                >
                                    <IconButton
                                        sx={{
                                            p: 1.5, backgroundColor: '#01A0E2',
                                            color: '#fff',
                                            '&:hover':
                                                { backgroundColor: '#01A0E2', color: '#fff' }
                                        }}
                                    >
                                        <EastIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container >
    );
};

export default OurCategories;